import PropTypes from "prop-types";
import React from "react";
import CrmAvatar from "../../../shared/components/CrmAvatar";
import SparkleIcon from "../../../shared/Icons/SparkleIcon";

const fmtTime = (iso) =>
  new Date(iso).toLocaleString("en-US", { hour: "numeric", minute: "2-digit" });

const LineupCard = ({ lineup, canManage, busyId, suggestedArtist, onAddArtist, onAddSuggested, onEditArtist, onRemoveArtist }) => {
  const empty = lineup.length === 0;
  const suggestion = canManage && empty && suggestedArtist && suggestedArtist.id ? suggestedArtist : null;
  const suggestionSubtitle = suggestion
    ? [suggestion.genre, suggestion.reason].filter(Boolean).join(" · ")
    : "";

  return (
    <div className="d2-card" style={{ padding: "20px" }}>
      <div className="d2-card-header" style={{ marginBottom: "12px" }}>
        <span style={{ fontSize: "16px", fontWeight: 600, color: "var(--sl-text-primary)" }}>Lineup</span>
        <a className="d2-card-link" href="#offers">Manage <i className="fas fa-arrow-right" style={{ fontSize: "10px" }} /></a>
      </div>

      {suggestion ? (
        <div className="d2-suggested">
          <div className="d2-suggested-label"><SparkleIcon /> Suggested artist</div>
          <div className="d2-suggested-artist">
            <CrmAvatar avatarUrl={suggestion.imageUrl} name={suggestion.name} size={32} className="team-avatar-sm" />
            <div>
              <div className="card-detail-value">{suggestion.name}</div>
              {suggestionSubtitle && <div className="card-detail-label">{suggestionSubtitle}</div>}
            </div>
          </div>
          <div className="d2-suggested-actions">
            <button type="button" className="d2-suggested-add" disabled={Boolean(busyId)} onClick={onAddSuggested}>Add to lineup</button>
            <button type="button" className="d2-suggested-search" onClick={onAddArtist}>Search instead</button>
          </div>
        </div>
      ) : empty ? (
        <div className="card-detail-label">No lineup yet.</div>
      ) : (
        lineup.map((act) => (
          <div className="card-detail-row" key={act.id}>
            <span style={{ marginRight: "12px", display: "inline-flex", flexShrink: 0 }}>
              {/* team-avatar-sm pins the avatar to 32px; the global .team-avatar rule
                  otherwise forces 40px !important, overflowing the wrapper and eating the gap. */}
              <CrmAvatar avatarUrl={act.imageUrl} name={act.name} size={32} className="team-avatar-sm" />
            </span>
            <div>
              <div className="card-detail-value">
                {act.permalink ? <a href={`/artists/${act.permalink}`}>{act.name || "Unnamed"}</a> : (act.name || "Unnamed")}
              </div>
              <div className="card-detail-label">{act.startTime ? `${act.actType} · ${fmtTime(act.startTime)}` : act.actType}</div>
            </div>
            {canManage && (
              <span className="d2-lineup-actions">
                <button type="button" className="d2-lineup-action" aria-label={`Edit ${act.name}`} onClick={() => onEditArtist(act)}>
                  <i className="far fa-pen" />
                </button>
                <button type="button" className="d2-lineup-action" aria-label={`Remove ${act.name}`} disabled={busyId === act.id} onClick={() => onRemoveArtist(act.id)}>
                  <i className="far fa-times" />
                </button>
              </span>
            )}
          </div>
        ))
      )}

      {canManage && !suggestion && (
        <button type="button" className="d2-add-artist" onClick={onAddArtist}>
          <i className="fas fa-plus" /> Add artist
        </button>
      )}
    </div>
  );
};

LineupCard.propTypes = {
  lineup: PropTypes.array.isRequired,
  canManage: PropTypes.bool,
  busyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  suggestedArtist: PropTypes.object,
  onAddArtist: PropTypes.func,
  onAddSuggested: PropTypes.func,
  onEditArtist: PropTypes.func,
  onRemoveArtist: PropTypes.func,
};

export default LineupCard;
